var path = 'components/acls/tooltips/vodsNames.html';
var html = "<div class=tooltip-list> <div ng-repeat=\"vod in acl.vods | orderBy\"> <span ng-bind=vod.name access=\"superAdmin !\"></span> <a ng-href=\"{{'vods/' + vod.id}}\" ng-bind=vod.name access=superAdmin></a> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;